import ActionTypes from "./types";

export const setAppStateAction = (newState) => async (dispatch) =>
  await dispatch({
    type: ActionTypes.SET_APP_STATE,
    payload: newState,
  });



// WEBPACK FOOTER //
// ./src/actions/appStateAction.js